/**
 * Returns the time formatted in "time ago" format
 *
 * @param {Number} time -- the time to format
 * @return {String} The formatted time
 */

export default function timeAgo(time) {
  if (typeof time === 'undefined') return 'Unknown'

  const minutes = (Date.now() - time) / (1000 * 60)
  
  if (minutes <= 1) return '1 minute ago'
  else if (minutes <= 59) return `${Math.ceil(minutes)} minutes ago`
  else if (minutes <= 60 * 1.5) return '1 hour ago'
  else if (minutes < 60 * 23.5) return `${Math.round(minutes / 60)} hours ago`
  else if (minutes <= 60 * 24 * 1.5) return '1 day ago'
  else if (minutes < 60 * 24 * 14) return `${Math.round(minutes / (60 * 24))} days ago`
  else {
    const date = new Date(time)
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
  }
}



// WEBPACK FOOTER //
// ./src/helpers/timeAgo.js